export type PanelItem = { text: string, value: number | string, key: number };

export const birimTurPanelItems: Array<PanelItem> = [
    {
      text: 'İç Birim',
      value: "I",
      key: 0,
    }, {
      text: 'Dış Birim',
      value: "R",
      key: 1,
    }, {
      text: 'Gerçek Kişi',
      value: "K",
      key: 2,
    }, {
      text: 'Tüzel Kişi',
      value: "T",
      key: 3,
    }
];

export const birimYetkiPanelItems: Array<PanelItem> = [
  {
    text: 'Birim/Kullanıcı',
    value: 0,
    key: 0,
  }, {
    text: 'Otomatik Evrak No',
    value: 1,
    key: 1,
  }, {
    text: 'Servis İletişim',
    value: 2,
    key: 2,
  }, 
];
export const dogrudanUstune: Array<PanelItem> = [
  {
    text: 'Doğrudan',
    value: 0,
    key: 0,
  }, {
    text: 'Üstüne',
    value: 1,
    key: 1,
  }
];
export const elektronikFiziksel: Array<PanelItem> = [
  {
    text: 'Elektronik',
    value: 0,
    key: 0,
  }, {
    text: 'Fiziksel',
    value: 1,
    key: 1,
  }
];
export const bilgiGeregi: Array<PanelItem> = [
  {
    text: 'Bilgi',
    value: 0,
    key: 0,
  }, {
    text: 'Gereği',
    value: 1,
    key: 1,
  }
];